import {Button, Drawer, message, Space} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {useGetCustomerStoreServicesOrdersContext} from "../../../../../../../service-feature/useCases/get-orders/context/customer";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {Controller, useForm} from "react-hook-form";
import TextArea from "antd/lib/input/TextArea";
import {yupResolver} from "@hookform/resolvers/yup";
import yup from "../../../../../../../utils/yup-extended";
import {useCustomerCancelStoreServiceOrderApi} from "../../../../../../../react-query-hooks/store/services/cancel-store-service-order";
import {StyledStoreServiceOrderDrawer} from "../styles";

export const storeServiceCustomerReviewRequestSchema = yup.object().shape({
  customerComment: yup.string().trim().required("Leave a comment"),
});

export function CustomerCancelStoreServiceOrderDrawer() {
  const {
    state: {selectedStoreServiceOrderInfo, activeStoreServiceOrderDrawer},
    dispatch,
  } = useGetCustomerStoreServicesOrdersContext();
  const customerCancelStoreServiceOrderApi = useCustomerCancelStoreServiceOrderApi();

  const {
    control,
    formState: {errors},
    watch,
    handleSubmit,
    reset,
  } = useForm<{
    customerComment: string;
  }>({
    resolver: yupResolver(storeServiceCustomerReviewRequestSchema),
    mode: "onSubmit",
    defaultValues: {
      customerComment: "",
    },
  });

  if (!selectedStoreServiceOrderInfo) return null; // or show a loader/skeleton
  const onOrderInfoDrawerClose = () => {
    reset();
    dispatch({
      type: "set-active-store-service-order-drawer",
      payload: "order-info",
    });
  };
  const onSubmit = (values: {customerComment: string}) => {
    // console.log({values});

    customerCancelStoreServiceOrderApi.mutate(
      {
        orderId: selectedStoreServiceOrderInfo.order.id,
        reason: values.customerComment,
        productServiceId: selectedStoreServiceOrderInfo.order.id,
      },
      {
        onSuccess() {
          message.success("Order cancelled successfully");
          onOrderInfoDrawerClose();
          dispatch({
            type: "update-status-id",
            payload: 6,
          });
        },
      }
    );
  };
  return (
    <StyledStoreServiceOrderDrawer
      title={selectedStoreServiceOrderInfo.productService.name}
      placement="right"
      onClose={onOrderInfoDrawerClose}
      visible={activeStoreServiceOrderDrawer === "cancel-order"}
      closable={false}
      extra={
        <Button size="small" type="text" onClick={onOrderInfoDrawerClose}>
          <CloseOutlined />
        </Button>
      }
    >
      <div>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <Space size={24} direction="vertical" style={{display: "flex"}}>
            <p>
              Please note that refunds are not automatic. Our support team will review the
              reason for cancellation and may contact you or the coach for clarification
              before processing any refund.
            </p>
            <FormField
              id="customerComment"
              label="Reasons for cancellation"
              renderInput={(id) => (
                <Controller
                  control={control}
                  name="customerComment"
                  render={({
                    field: {onChange, value, ref, onBlur},
                    fieldState: {error},
                  }) => (
                    <Space size={8} direction="vertical" style={{display: "flex"}}>
                      <TextArea
                        id={id}
                        status={error?.message ? "error" : ""}
                        onChange={onChange}
                        onBlur={onBlur}
                        size="large"
                        value={value === null ? undefined : value}
                        placeholder="Let them know why you are cancelling this order"
                        ref={ref}
                      />
                      <FormFieldError errorMessage={error?.message} />
                    </Space>
                  )}
                />
              )}
            />
            <div>
              <Button
                disabled={
                  Object.keys(errors).length > 0 || Object.values(watch()).length < 1
                }
                loading={customerCancelStoreServiceOrderApi.isLoading}
                htmlType="submit"
                size="small"
                type="primary"
              >
                Submit
              </Button>
            </div>
          </Space>
        </form>
      </div>
    </StyledStoreServiceOrderDrawer>
  );
}
